import api from '@/api';

const store = {
  state: {
    settingItem: {},
    resMessage: null,
    isFetchingData: false
  },

  mutations: {
    SET_SETTING_ITEM: (state, payload) => {
      state.settingItem = payload;
    },
    SET_RES_MESSAGE: (state, payload) => {
      state.resMessage = payload;
    },
    SET_FETCHING_DATA: (state, payload) => {
      state.isFetchingData = payload;
    }
  },

  getters: {
    GetSettingItem: state => state.settingItem,
    GetResMessage: state => state.resMessage,
    GetFetchingData: state => state.isFetchingData
  },

  actions: {
    async GetDeliverySetting({ commit }) {
      try {
        commit('SET_FETCHING_DATA', true);
        const res = await api.GetDeliverySetting();
        commit('SET_SETTING_ITEM', res.data.result);
        commit('SET_FETCHING_DATA', false);
        return res;
      } catch (e) {
        return e.response;
      }
    },

    async CreatedDeliverySetting({ commit }, payload) {
      try {
        const res = await api.CreatedDeliverySetting(payload);
        commit('SET_RES_MESSAGE', res.data.status);
        return res;
      } catch (e) {
        throw e;
      }
    }
  }
};

export default store;
